import { render } from "./block.vue?vue&type=template&id=eb4c93b0"
import script from "./block.vue?vue&type=script&lang=js"
export * from "./block.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__